import '../../LayerType'
import './Base'
import './OL3/Vector'

/** @namespace GIS.Map.Layer */
NS("GIS.Map.Layer");

/**
 * @class
 * @extends GIS.Map.Layer.Base
 */
GIS.Map.Layer.Vector = Class(GIS.Map.Layer.Base, /** @lends GIS.Map.Layer.Vector.prototype */ {
    vendors: {
        "ol3": GIS.Map.Layer.OL3.Vector
    },
    // options
    /** @type {glStyleHash} */
    style: null,
    /** @type {string} Format name */
    format: null,
    geometryName: "geometry",
    dataGeometryName: "geojson",
    dataPrimaryKeyName: "id",
    dataGeometryNameMap: undefined,
    clusterDistance: null,
    loadingStrategy: "tile",
    tileSize: [1024, 1024],
    asImage: false,
    /**
     * @type {function(extent: number[], resolution: number, projection: string)}
     */
    loader: null,
    /**
     * @inheritDoc
     */
    initialize()
    {
        this.ParentCall();

        this.layer.on("feature.insert", this.onLayerFeatureInsert, this)
            .on("feature.update", this.onLayerFeatureUpdate, this)
            .on("feature.remove", this.onLayerFeatureRemove, this)
            .on("click", this.onLayerClick, this)
            .on("feature.click", this.onLayerFeatureClick, this)
            .on("feature.select", this.onLayerFeatureSelect, this)
            .on("feature.unselect", this.onLayerFeatureUnselect, this)
            .on("before.load", this.onLayerBeforeLoad, this)
            .on("load", this.onLayerLoad, this)
            .on("after.load", this.onLayerAfterLoad, this);
    },
    /** @inheritDoc */
    optionsNames()
    {
        return this.ParentCall().concat([
            'format', 'geometryName', 'dataGeometryName', 'dataPrimaryKeyName', 'dataGeometryNameMap',
            'clusterDistance', 'style', 'loader', 'loadingStrategy', 'tileSize', 'asImage'
        ])
    },
    /**
     * @inheritDoc
     */
    prepareOptions(options)
    {
        options = this.Parent(options);

        if (options.tileSize != null && !_.isArray(options.tileSize)) {
            options.tileSize = [_.parseInt(options.tileSize)];
        }

        return options;
    },
    /** @inheritDoc */
    destroy()
    {
        this.loader = null;

        return this.ParentCall();
    },
    /**
     * @param {*} data
     * @returns {Promise<Array<T>>}
     */
    read(data)
    {
        return this.layer.read(data);
    },
    /**
     * @param {glStyleHash} styleHash New style hash
     * @param {boolean} [merge=true] Merge with existing style hash or overwrite it
     * @returns {GIS.Map.Layer.Vector}
     */
    setStyle(styleHash, merge)
    {
        return this.layer.setStyle(styleHash, merge);
    },
    /**
     * @returns {*}
     */
    getStyle()
    {
        return this.layer.getStyle();
    },
    /**
     * @param {string|string[]} path Style option path
     * @param {*} value
     * @returns {GIS.Map.Layer.Vector}
     */
    setStyleOption(path, value)
    {
        this.layer.setStyleOption(path, value);

        return this;
    },
    /**
     * @param {string|string[]} path Style option path
     * @returns {*} Returns style option value at specified path
     */
    getStyleOption(path)
    {
        return this.layer.getStyleOption(path);
    },
    /**
     * @param {*} feature
     * @param {string} [styleName=default]
     * @param {string | undefined} [prevStyleName]
     * @returns {GIS.Map.Layer.Vector}
     */
    setFeatureStyleName(feature, styleName = 'default', prevStyleName = undefined)
    {
        this.layer.setFeatureStyleName(feature, styleName, prevStyleName);

        return this;
    },
    /**
     * @param {*} feature
     * @return {string}
     */
    getFeatureStyleName (feature) {
        return this.layer.getFeatureStyleName(feature)
    },
    /**
     * @param {Object} geog
     * @param {Object} [data]
     * @returns {*}
     */
    insert(geog, data)
    {
        return this.layer.insert(geog, data);
    },
    /**
     * @param {(number|string)} id
     * @param {Object} data
     * @returns {*}
     */
    update(id, data)
    {
        return this.layer.update(id, data);
    },
    /**
     * @param {(number|string)} id
     * @returns {*}
     */
    remove(id)
    {
        return this.layer.remove(id);
    },
    /**
     * @returns {GIS.Map.Layer.Vector}
     */
    clear()
    {
        this.layer.clear();

        return this;
    },
    /**
     * @returns {number[]|undefined}
     */
    getExtent()
    {
        return this.layer.getExtent();
    },
    /**
     * @returns {number}
     */
    getType()
    {
        return GIS.LayerType.Vector;
    },
    /**
     * @param {number|string} id
     * @returns {*}
     */
    getFeature(id)
    {
        return this.layer.getFeature(id);
    },
    /**
     * @returns {Array}
     */
    getFeatures()
    {
        return this.layer.getFeatures();
    },
    /**
     * @fires GIS.Map.Layer.Vector#feature.insert
     * @param {{feature: *}} e
     * @protected
     */
    onLayerFeatureInsert(e)
    {
        /**
         * @event GIS.Map.Layer.Vector#feature.insert
         * @type {{feature: *}}
         */
        this.emit("feature.insert", e);
    },
    /**
     * @fires GIS.Map.Layer.Vector#feature.update
     * @param {{feature: *}} e
     * @protected
     */
    onLayerFeatureUpdate(e)
    {
        /**
         * @event GIS.Map.Layer.Vector#feature.update
         * @type {{feature: *}}
         */
        this.emit("feature.update", e);
    },
    /**
     * @fires GIS.Map.Layer.Vector#feature.remove
     * @param {{feature: *}} e
     * @protected
     */
    onLayerFeatureRemove(e)
    {
        /**
         * @event GIS.Map.Layer.Vector#feature.remove
         * @type {{feature: *}}
         */
        this.emit("feature.remove", e);
    },
    /**
     * @fires GIS.Map.Layer.Vector#click
     * @param {{pixel: number[], coordinate: number[]}} e
     */
    onLayerClick(e)
    {
        /**
         * @event GIS.Map.Layer.Vector#click
         * @type {{pixel: number[], coordinate: number[]}}
         */
        this.emit("click", e);
    },
    /**
     * @fires GIS.Map.Layer.Vector#feature.click
     * @param {{pixel: number[], coordinate: number[], feature: *}} e
     */
    onLayerFeatureClick(e)
    {
        /**
         * @event GIS.Map.Layer.Vector#feature.click
         * @type {{pixel: number[], coordinate: number[], feature: *}}
         */
        this.emit("feature.click", e);
    },
    /**
     * @param e
     * @fires GIS.Map.Layer.Vector#feature.select
     */
    onLayerFeatureSelect(e)
    {
        this.emit("feature.select", e);
    },
    /**
     * @param e
     * @fires GIS.Map.Layer.Vector#feature.unselect
     */
    onLayerFeatureUnselect(e)
    {
        this.emit("feature.unselect", e);
    },
    /**
     * @fires GIS.Map.Layer.Vector#before.load
     * @param {{extent: number[], resolution: number, projection: string}} e
     * @protected
     */
    onLayerBeforeLoad(e)
    {
        this.emit("before.load", e);
    },
    onLayerLoad(evt)
    {
        this.emit('load', evt);
    },
    /**
     * @fires GIS.Map.Layer.Vector#after.load
     * @param {{extent: number[], resolution: number, projection: string, response: Object}} e
     * @protected
     */
    onLayerAfterLoad(e)
    {
        this.emit("after.load", e);
    },
    /**
     * @param {*} feature
     * @returns {GIS.Map.Layer.Vector}
     */
    selectFeature(feature)
    {
        this.layer.selectFeature(feature);

        return this;
    },
    /**
     * @param {*} feature
     * @returns {GIS.Map.Layer.Vector}
     */
    unselectFeature(feature)
    {
        this.layer.unselectFeature(feature);

        return this;
    }
});
